import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=2878a532&scoped=true&"
import script from "./lock.vue?vue&type=script&lang=ts&"
export * from "./lock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878a532",
  null
  
)

export default component.exports